var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app_footer" }, [
    _vm._m(0),
    _c("section", { staticClass: "main_section section_footer" }, [
      _c("div", { staticClass: "section_content" }, [
        _vm._m(1),
        _c(
          "div",
          { staticClass: "footer_col" },
          [
            _c(
              "nuxt-link",
              { staticClass: "footer_link", attrs: { to: "/" } },
              [_vm._v("Homepage")]
            ),
            _c(
              "a",
              {
                staticClass: "footer_link",
                on: {
                  click: function($event) {
                    return _vm.clickMenuItem("dataset")
                  }
                }
              },
              [_vm._v("Datasets")]
            ),
            _c(
              "a",
              {
                staticClass: "footer_link",
                on: {
                  click: function($event) {
                    return _vm.clickMenuItem("country")
                  }
                }
              },
              [_vm._v("Countries")]
            ),
            _c(
              "nuxt-link",
              { staticClass: "footer_link", attrs: { to: "/download-data/" } },
              [_vm._v("Download data & methodology")]
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "footer_col" },
          [
            _c("div", { staticClass: "col_title" }, [_vm._v("MORE")]),
            _c(
              "nuxt-link",
              { staticClass: "footer_link", attrs: { to: "/research-briefs" } },
              [_vm._v("Research briefs")]
            ),
            _c(
              "nuxt-link",
              { staticClass: "footer_link", attrs: { to: "/about/" } },
              [_vm._v("About")]
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "footer_col" },
          [
            _c(
              "a",
              {
                staticClass: "footer_link",
                on: {
                  click: function($event) {
                    return _vm.openCookies()
                  }
                }
              },
              [_vm._v("Cookies settings")]
            ),
            _c(
              "nuxt-link",
              { staticClass: "footer_link", attrs: { to: "/privacy-policy/" } },
              [_vm._v("Privacy policy")]
            ),
            _c("div", { staticClass: "col_watermark" }, [_vm._v("©EUTO 2021")])
          ],
          1
        ),
        _vm._m(2),
        _c("a", {
          staticClass: "footer_wdd",
          attrs: { href: "https://wedodata.fr/", target: "_blank" }
        })
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      {
        staticClass: "main_section section_contact nomargin",
        attrs: { id: "SectionContact" }
      },
      [
        _c("div", { staticClass: "section_content" }, [
          _c("div", { staticClass: "content_text" }, [
            _c("div", { staticClass: "text_title" }, [_vm._v("Contact us")]),
            _c("div", { staticClass: "text_questions" }, [
              _c("div", { staticClass: "text_question" }, [
                _vm._v("Have a question?")
              ]),
              _c("div", { staticClass: "text_question" }, [
                _vm._v("A comment?")
              ]),
              _c("div", { staticClass: "text_question" }, [
                _vm._v(
                  "Want to know more about The Atlas of the Offshore World?"
                )
              ])
            ]),
            _c("div", { staticClass: "text_more" }, [
              _vm._v(
                "\n                    The staff at the International Tax Observatory is there to answer your question! Register now to join our weekly online Question Hour where you can speak directly with our staff.\n                "
              )
            ])
          ]),
          _c(
            "a",
            {
              staticClass: "content_extlink",
              attrs: {
                href: "https://airtable.com/shrIDppNLWSCVhbI0",
                target: "_blank"
              }
            },
            [
              _c("span", [
                _vm._v("Register now to join our Question Hour sessions")
              ])
            ]
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "footer_col", attrs: { "data-col": "logos" } },
      [
        _c("div", { staticClass: "col_logo", attrs: { "data-logo": "ito" } }),
        _c("div", { staticClass: "col_logo", attrs: { "data-logo": "skat" } })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "footer_col", attrs: { "data-col": "share" } },
      [
        _c("div", { staticClass: "col_title" }, [_vm._v("FOLLOW US ON")]),
        _c("div", { staticClass: "col_icons" }, [
          _c("a", {
            staticClass: "col_icon",
            attrs: {
              href:
                "https://www.facebook.com/people/EU-Tax-Observatory/100075536903031/",
              target: "_blank",
              "data-icon": "fb"
            }
          }),
          _c("a", {
            staticClass: "col_icon",
            attrs: {
              "data-icon": "tw",
              href: "https://twitter.com/taxobservatory",
              target: "_blank"
            }
          }),
          _c("a", {
            staticClass: "col_icon",
            attrs: {
              "data-icon": "lk",
              href: "https://www.linkedin.com/company/eu-tax-observatory/",
              target: "_blan"
            }
          })
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10fef671", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10fef671","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/appFooter.vue
// module id = JVRI
// module chunks = 0 1 2 3 4 5 6 7 8